import Layout from "./Layout";
import RequireAuth from "./RequireAuth";

export default {
  Layout,
  RequireAuth,
};
